module.exports = __webpack_public_path__ + "img/skirt_length.254a57e9.png";